import MonitorIcon from './components/AppLayout/MonitorIcon';
import ManageIcon from './components/AppLayout/ManageIcon';
import CustomerIcon from './components/AppLayout/CustomerIcon';
import DashboardIcon from './components/AppLayout/DashboardIcon';
import DealersIcon from './components/AppLayout/DealersIcon';
import MeasureModelIcon from './components/AppLayout/MeasureModelIcon';
import { Trans } from '@lingui/react/macro';

export const navItems = [
  {
    title: <Trans>Dashboard</Trans>,
    id: 'overview',
    path: '/dashboard',
    icon: DashboardIcon,
  },
  {
    title: <Trans>Customers</Trans>,
    id: 'customers',
    path: 'customers',
    icon: CustomerIcon,
  },
  {
    title: <Trans>Dealers</Trans>,
    id: 'dealers',
    path: 'dealers',
    icon: DealersIcon,
  },
  { title: '', id: 'divider', kind: 'divider' },
  {
    title: <Trans>Measure & Model</Trans>,
    id: 'measureModel',
    path: 'measure-model',
    icon: MeasureModelIcon,
  },
  {
    title: <Trans>Monitor</Trans>,
    id: 'monitor',
    path: 'monitor',
    icon: MonitorIcon,
  },
  {
    title: <Trans>Manage</Trans>,
    id: 'assetManager',
    path: 'asset-manager',
    icon: ManageIcon,
  },
];
